
import "@/assets/css/vtbpay-btn.css"
import {defineComponent} from 'vue'


export default defineComponent({
  emits: ['btn:click']
})
